import PassportOffer from '../components/passport-offer/PassportOffer.svelte';

const tagName = 'teuteuf-passport-offer';

const element = PassportOffer.element;

if (element && !customElements.get(tagName)) {
  customElements.define(tagName, element);
}
